// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3a_vn","fullScreen":"Loader_fullScreen__OK6Zj","loaderChildren":"Loader_loaderChildren__2HDeE","loaderIcon":"Loader_loaderIcon__1h7cy"};